module.exports = __webpack_public_path__ + "img/雨.b5440c68.png";